import React from 'react'

import { styled } from '@mui/material/styles'

export interface IOwnProps {
  className?: string
  text: string
}

export type IProps = IOwnProps

const Status:React.FC<IOwnProps> = (props) => {
  const {
    className,
    text,
  } = props

  return (
    <div className={className}>
      { text }
    </div>
  )
}

export default styled(Status)(({ theme }) => ({
  display: 'inline-block',
  padding: '2px 7px',
  borderRadius: 28,
  fontSize: 11,
  color: theme.palette.error.main,
  fontWeight: 400,
  textDecoration: 'none',
  backgroundColor: 'rgba(217, 0, 27, 0.1)',
}))
